// extracted by mini-css-extract-plugin
module.exports = {"indicatorHolder":"CardIndicator_indicatorHolder__19Yfu","indicator":"CardIndicator_indicator__Whvi5","selectedIndicator":"CardIndicator_selectedIndicator__3fV8n"};